
export default class ColorThemeController {

	constructor() {

		this.el = {
			sections: document.querySelectorAll('[data-color-theme]'),
			body: document.querySelector('body')
		};

		this.currentBackgroundColor = '';

		this._addListeners();
		this._onScroll();

		setTimeout(() => {
			this._domReady();
		}, 100);
	}

	_domReady() {
		this._onScroll();
	}

	_addListeners() {

		this._onScroll = this._onScroll.bind(this);

		window.addEventListener('scroll', this._onScroll);
	}

	//

	_onScroll() {
		this.checkSectionPositions();
	}

	//

	checkSectionPositions() {

		if( this.el.sections.length == 0 ){
			return;
		}

		const scrollTop = window.pageYOffset;

		for( let i = this.el.sections.length; i--; ){

			let section = this.el.sections[ i ];
			let offsetTop = section.offsetTop;
			let winHeight = window.innerHeight / 2;
			let height = section.offsetHeight;
			let backgroundColor = section.getAttribute('data-color-theme');

			if (scrollTop >= (offsetTop - winHeight) && scrollTop < ((offsetTop - winHeight) + height)) {
				if( backgroundColor !== this.currentBackgroundColor ){
					this.currentBackgroundColor = backgroundColor;
					this.el.body.setAttribute('data-color-theme', backgroundColor);
				}
			}
		}
	}
}
